import { UserRole } from "authentication/userrole";
import { ROUTES } from "../../routes";

interface IMenuRoute {
  name: string;
  target: string;
  allowedRoles?: Array<UserRole>;
}

const MenuRoutes: Array<IMenuRoute> = [
  { name: "Breadcrumb_Start", target: ROUTES.HOME },
];

export default MenuRoutes;
